<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import McpConnectorForm from './McpConnectorForm.vue';

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const selectedConnector = ref(null);
const mode = ref('create');
const formKey = ref(0);

const i18nKey = computed(
  () => `CAPTAIN.MCP_CONNECTORS.${mode.value.toUpperCase()}`
);

const open = (connector = null) => {
  selectedConnector.value = connector;
  mode.value = connector?.id ? 'edit' : 'create';
  formKey.value += 1;
  dialogRef.value.open();
};

const handleSubmit = async connectorDetails => {
  try {
    if (mode.value === 'edit') {
      await store.dispatch('captainMcpConnectors/update', {
        id: selectedConnector.value.id,
        ...connectorDetails,
      });
    } else {
      await store.dispatch('captainMcpConnectors/create', connectorDetails);
    }
    useAlert(t(`${i18nKey.value}.SUCCESS_MESSAGE`));
    dialogRef.value.close();
  } catch (error) {
    const errorMessage =
      parseAPIErrorResponse(error) || t(`${i18nKey.value}.ERROR_MESSAGE`);
    useAlert(errorMessage);
  }
};

const handleClose = () => {
  emit('close');
};

const handleCancel = () => {
  dialogRef.value.close();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="2xl"
    :title="t(`${i18nKey}.TITLE`)"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="handleClose"
  >
    <McpConnectorForm
      :key="formKey"
      :mode="mode"
      :connector="selectedConnector"
      @submit="handleSubmit"
      @cancel="handleCancel"
    />
    <template #footer />
  </Dialog>
</template>
